// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as WebapiUtils$Showside from "../utils/WebapiUtils.bs.js";
function useDocumentReadyStateChange(param) {
  var match = React.useState(function () {
    return WebapiUtils$Showside.$$Document.readyState(document);
  });
  var setReadyState = match[1];
  React.useEffect(function () {
    var handleReadyStateChange = function (param) {
      Curry._1(setReadyState, function (param) {
        return WebapiUtils$Showside.$$Document.readyState(document);
      });
    };
    document.addEventListener("readystatechange", handleReadyStateChange);
    return function (param) {
      document.removeEventListener("readystatechange", handleReadyStateChange);
    };
  }, []);
  return match[0];
}
export { useDocumentReadyStateChange };
/* react Not a pure module */